export default __webpack_public_path__ + "static/media/chronograph.35895978.jpeg";